






















































import Vue from "vue";
import { Form, Select } from "element-ui";
import { mapActions } from "vuex";

interface InviteListItem {
  userName: string;
  userId: string;
}

export default Vue.extend({
  name: "Invite",
  props: { projectId: { type: String }, tenantId: { type: String } },
  data() {
    return {
      dialog: false,
      roleOptions: [
        {
          value: "PROJECT_ADMIN",
          name: "项目管理员"
        },
        {
          value: "PROJECT_REGULAR",
          name: "普通用户"
        }
      ],
      inviteListData: new Array<InviteListItem>(),
      form: {
        userIds: new Array<string>(),
        role: ""
      },
      rules: {
        userIds: [
          { required: true, message: "请选择需要邀请的用户", trigger: "blur" }
        ],
        role: [{ required: true, message: "请选择角色", trigger: "blur" }]
      }
    };
  },
  beforeDestroy() {
    document.removeEventListener("click", this.selectBlur);
  },
  methods: {
    ...mapActions("PrjMembers", ["inviteUser"]),
    show(data: any) {
      if (data) {
        data.map((e: any) => {
          this.inviteListData.push({
            userName: e.userName,
            userId: e.id
          });
        });
      }
      this.dialog = true;
    },
    quit() {
      this.inviteListData = (this as any).$options.data().inviteListData;
      this.form = (this as any).$options.data().form;
      (this.$refs.form as Form).resetFields();
      this.dialog = false;
    },
    submit() {
      (this.$refs.form as any).validate((valid: any) => {
        if (valid) {
          this.inviteUser({
            projectId: this.projectId,
            tenantId: this.tenantId,
            form: this.form
          });
          this.quit();
        }
      });
    }, // 下拉框 focus 事件
    formClick() {
      // 监听 dom click 事件
      document.removeEventListener("click", this.selectBlur);
      document.addEventListener("click", this.selectBlur);
    },
    selectBlur() {
      // 手动关闭下拉框 options
      (this.$refs.select as Select).blur();
    }
  }
});
